/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free IUPAC-to-regex tool. Turn a degenerate nucleotide motif (with codes like N, R, Y, W) into a regular expression you can use to search DNA sequences.`)
};

const es_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita de IUPAC a regex. Convierte un motivo de nucleótidos degenerado (con códigos como N, R, Y, W) en una expresión regular que puedes usar para buscar en secuencias de ADN.`)
};

const de_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses IUPAC-zu-Regex-Tool. Wandeln Sie ein degeneriertes Nukleotidmotiv (mit Codes wie N, R, Y, W) in einen regulären Ausdruck um, mit dem Sie DNA-Sequenzen durchsuchen können.`)
};

const nl_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis IUPAC-naar-regextool. Zet een degeneratief nucleotidemotief (met codes zoals N, R, Y, W) om naar een reguliere expressie waarmee je DNA-sequenties kunt doorzoeken.`)
};

const fr_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit IUPAC vers regex. Transformez un motif nucléotidique dégénéré (avec des codes comme N, R, Y, W) en une expression régulière que vous pouvez utiliser pour rechercher des séquences d'ADN.`)
};

const it_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito da IUPAC a espressione regolare. Trasforma un motivo nucleotidico degenerato (con codici come N, R, Y, W) in un'espressione regolare da usare per cercare sequenze di DNA.`)
};

const pt_br2_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de IUPAC para regex. Transforme um motivo de nucleotídeos degenerado (com códigos como N, R, Y, W) em uma expressão regular que você pode usar para buscar em sequências de DNA.`)
};

const pt_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de IUPAC para regex. Transforme um motivo de nucleótidos degenerado (com códigos como N, R, Y, W) numa expressão regular que pode usar para pesquisar sequências de ADN.`)
};

const ja_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のIUPAC→正規表現ツール。N、R、Yなどのコードを含む縮重ヌクレオチドモチーフを正規表現に変換し、DNA配列の検索に使えます。`)
};

const zh_iupac_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 IUPAC 转正则表达式工具。将带有简并码（如 N、R、Y、W）的核苷酸模体转换为正则表达式，用于搜索 DNA 序列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_meta_description", locale)
	if (locale === "en") return en_iupac_meta_description(inputs)
	if (locale === "es") return es_iupac_meta_description(inputs)
	if (locale === "de") return de_iupac_meta_description(inputs)
	if (locale === "nl") return nl_iupac_meta_description(inputs)
	if (locale === "fr") return fr_iupac_meta_description(inputs)
	if (locale === "it") return it_iupac_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_meta_description(inputs)
	if (locale === "pt") return pt_iupac_meta_description(inputs)
	if (locale === "ja") return ja_iupac_meta_description(inputs)
	return zh_iupac_meta_description(inputs)
};